import { Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react';
import { useSearchParams } from 'next/navigation';
import React from 'react';

import { IconFilter } from '@/assets';
import useCreateQueryString from '@/hooks/useCreateQueryString';

import { ACTIVITY_LIST_TYPE_TRANSACTION } from './constants';

const ActivityFilter: React.FC = () => {
  const createQueryString = useCreateQueryString();
  const params = useSearchParams();
  const typeTransaction = params.get('event');

  const onSelectType = (key: string) => {
    if (typeTransaction === key) createQueryString('page', 1, { scroll: false }, 'event');
    else createQueryString(['event', 'page'], [key, 1], { scroll: false });
  };

  return (
    <div className="mb-6 flex justify-end">
      <Popover
        showArrow
        offset={10}
        placement="bottom"
        motionProps={{
          variants: {
            enter: {
              y: 0,
              opacity: 1,
              transition: {
                opacity: {
                  duration: 0.15,
                },
              },
            },
            exit: {
              y: '10%',
              opacity: 0,
              transition: {
                opacity: {
                  duration: 0.1,
                },
              },
            },
          },
        }}
      >
        <PopoverTrigger>
          <div className="flex h-[40px] min-w-[100px] cursor-pointer items-center justify-center rounded-full bg-gray-50 p-3 text-[14px]">
            <IconFilter className="-ml-1 mr-1 scale-80" /> Filter
          </div>
        </PopoverTrigger>
        <PopoverContent>
          <div className="w-[265px] px-2 py-4">
            <div className="">
              <div className="pb-2 text-14 font-semibold leading-6">Type</div>
              <div className="flex flex-wrap gap-2">
                {ACTIVITY_LIST_TYPE_TRANSACTION.map((type) => (
                  <div
                    aria-checked={typeTransaction === type.key}
                    key={type.key}
                    className="w-fit cursor-pointer rounded-[50px] border-1 border-gray-100 px-[12px]  py-[6px] text-13 text-black aria-checked:border-black"
                    onClick={() => onSelectType(type.key)}
                  >
                    <span className="">{type.title}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* <div className="">
                <div className="pb-2 text-14 font-semibold leading-6">Date created</div>
                <div className="flex gap-2">
                  {LIST_SORT.map(sort => (
                    <div
                      aria-checked={createdAt === sort.key}
                      key={sort.key}
                      className="w-fit aria-checked:border-black cursor-pointer rounded-[50px] border-1 border-gray-100  px-[12px] py-[6px] text-13 text-black"
                      onClick={() => createQueryString('createdAt', sort.key, { scroll: false })}
                    >
                      <span className="">{sort.title}</span>
                    </div>
                  ))}
                </div>
              </div> */}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default ActivityFilter;
